import { createSurveyStyles } from '@sm/webassets';
import { SurveyThemeType } from '@sm/webassets/dist/components/SurveyTheme';

type FooterClassNames = 'surveyFooter' | 'privacyComponentContainer';
const useStyles = createSurveyStyles<FooterClassNames>((theme: SurveyThemeType) => ({
  surveyFooter: {},
  privacyComponentContainer: {
    paddingTop: 80,
    margin: '0 auto',
    textAlign: 'center',
  },
}));

export default useStyles;
